import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import "./assets/styles/variables.css";
import "element-ui/lib/theme-chalk/index.css";
import router from "./router";
import service from "./utils/service";
import "font-awesome/css/font-awesome.min.css";
import * as utils from "./utils";
import "./assets/styles/element-theme.less";

import store from "./store";
Vue.prototype.$store = store;
Vue.prototype.$utils = utils;
Vue.prototype.service = service;
Vue.use(ElementUI);
Vue.config.productionTip = false;

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
const key = "THEME";
const mode = localStorage.getItem(key);
if (mode) {
  document.documentElement.setAttribute("data-theme", mode);
} else {
  document.documentElement.setAttribute("data-theme", utils.detectTheme());
}

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
console.log("process", process.env);
